$(function () {
  var $header = $('#header-sticky');
  var $announce = $('.announcebar');
  var lastY = window.pageYOffset || 0;
  var ticking = false;

  // thresholds
  var thresholdHide = 6;     // scroll down delta to hide header
  var thresholdShow = 4;     // scroll up delta to show header
  var minScrollToHide = 60;  // don't hide until user scrolled a bit

  function measureHeights() {
    // Announcement bar height (if present & visible)
    var annH = ($announce.length && $announce.is(':visible')) ? $announce.outerHeight() : 0;
    document.body.style.setProperty('--announce-h', annH + 'px');

    // Header height
    var h = $header.outerHeight();
    document.body.style.setProperty('--header-h', h + 'px');

    // Ensure body has the padding class
    if (!document.body.classList.contains('has-fixed-header')) {
      document.body.classList.add('has-fixed-header');
    }
  }

  function onScroll() {
    if (!ticking) {
      window.requestAnimationFrame(function () {
        var y = window.pageYOffset || 0;
        var delta = y - lastY;

        if (delta > thresholdHide && y > minScrollToHide) {
          $header.addClass('is-hidden');
        } else if (delta < -thresholdShow) {
          $header.removeClass('is-hidden');
        }

        lastY = y;
        ticking = false;
      });
      ticking = true;
    }
  }

  // Initial calc and listeners
  measureHeights();
  $(window).on('resize', measureHeights);
  $(window).on('scroll', onScroll);

  // In case the announcement bar content loads async (fonts/images),
  // re-measure once more after load.
  window.addEventListener('load', measureHeights);
});



$(document).ready(function () {

    // address page
    $('.edit-spacer input[type="hidden"][name="_method"][value="put"]').remove();
  
    $(".menu-lnk.has-item").hover(function(){
     $(this).toggleClass("menu_active");
    $(this).find(".menu-dropdown").toggleClass("open_menu");
    $("body").toggleClass("no-scroll");
  });
    jQuery(".product-write-review").on('click',function(e) {
    $(".product-review").toggleClass("open-model");
    $('body').addClass('no-scroll open');
    $('.overlay').addClass('active');
  });
  jQuery(".overlay,.review-close-icon").on('click',function(e) {
    $(".product-review").removeClass("open-model");
    $('body').removeClass('no-scroll open');
    $('.overlay').removeClass('active');
  });

  countDownIni('.flip-countdown,.js-flip-countdown');
  /*********  size Popup  ********/ 
      $(".size-btn").click(function() { 
        $(".size-popup").toggleClass("active"); 
        $("body").toggleClass("no-scroll");
    });
    $(".close-search").click(function() { 
        $(".size-popup").removeClass("active"); 
        $("body").removeClass("no-scroll");
    });
    $(".close-btn").click(function() { 
        $(".size-popup").removeClass("active"); 
        $("body").removeClass("no-scroll");
    });

  /********* Mobile Menu ********/
  $('.mobile-menu-button').on('click', function (e) {
    e.preventDefault();
    setTimeout(function () {
      $('body').addClass('no-scroll active-menu');
      $(".mobile-menu-wrapper").toggleClass("active-menu");
      $('.overlay').addClass('menu-overlay');
    }, 50);
  });
  $('body').on('click', '.overlay.menu-overlay, .menu-close-icon svg', function (e) {
    e.preventDefault();
    $('body').removeClass('no-scroll active-menu');
    $(".mobile-menu-wrapper").removeClass("active-menu");
    $('.overlay').removeClass('menu-overlay');
  });
  /********* Mobile Filter Popup ********/
    $('.mobile-facets__open').on('click', function (e) {
    $('body').addClass('mobile-open no-scroll');
    $('.overlay').addClass('active');
  });
  $('.overlay,.close-filter,.apply-btn').on('click', function (e) {
    $('body').removeClass('mobile-open no-scroll overflow-hidden-mobile');
    $('.overlay').removeClass('active');
  });
    /********* Cart Popup ********/
    if ($('body').hasClass('cart')) {
      // Disable click on the cart-header div
      $('.cart-header').on('click', function(event) {
        event.preventDefault();
        return false;
      });
    }
    else{
    $('.cart-header').on('click', function (e) {
    e.preventDefault();
    setTimeout(function () {
      $('body').addClass('no-scroll cartOpen');
      $('.overlay').addClass('cart_overlay');
    }, 50);
  });
  }
  $('body').on('click', '.overlay.cart_overlay, .closecart', function (e) {
    e.preventDefault();
    $('.overlay').removeClass('cart_overlay');
    $('body').removeClass('no-scroll cartOpen');
    $('.coupon-popup').removeClass('active');
    $('.gift-popup').removeClass('active');
  });

   /*********coupon popup ********/
  $(document).on('click', '.coupan-icon', function () {
    $(".coupon-popup").toggleClass("active");
  });
  $(document).on('click', '.gift-icon', function () {
    $(".coupon-popup").removeClass("active");
  });
  $(document).on('click', '.close-coupon', function () {
    $(".coupon-popup").removeClass("active");
  });
  
  // coupan code
    $('body').on('keyup','.discount-coupon', function() {
     var apply_href = $('.apply').attr("href").split('discount=')[0];
     var val = $(this).val();
      $('.apply').attr("href",apply_href+'discount='+val);
       $('.apply').trigger('click');
    });

  /*********gift popup ********/
  $(document).on('click', '.gift-icon', function () {
    $(".gift-popup").toggleClass("active");
  });
  $(document).on('click', '.coupan-icon', function () {
    $(".gift-popup ").removeClass("active");
  });
  $(document).on('click', '.close-gift', function () {
    $(".gift-popup").removeClass("active");
  });
  /******* Cookie Js *******/
  $('.cookie-close').click(function () {
    $('.cookie').slideUp();
  });
  /******* Subscribe popup Js *******/
    if ($('.subscribe-popup').length > 0) {
    $('body').addClass('no-scroll');
  }
    $('.close-sub-btn').click(function () {
      $('.subscribe-popup').slideUp(); 
      $(".subscribe-overlay").removeClass("open");
      $('body').removeClass('no-scroll');
    });   

/*********  Multi-level accordion nav  ********/
$('body').on('click', '.acnav-label', function (e) {
  e.preventDefault(); // stop label links from navigating (e.g., to "/")
  const label  = $(this);
  const parent = label.parent('.has-children');
  const list   = label.siblings('.acnav-list');

  if (parent.hasClass('is-open')) {
    list.slideUp('fast');
    parent.removeClass('is-open');
  } else {
    list.slideDown('fast');
    parent.addClass('is-open');
  }
});

  // add / remove active 
  $('.cat-ul li').click(function () {
    $('.cat-ul li').removeClass('active');
    $(this).addClass('active');
  });
  // counter js 
  var counted = 0;
  $('.count').each(function () {
    var $this = $(this),
      countTo = $this.attr('data-count');
    $({
      countNum: $this.text()
    }).animate({
      countNum: countTo
    },
      {
        duration: 2000,
        easing: 'swing',
        step: function () {
          $this.text(Math.floor(this.countNum));
        },
        complete: function () {
          $this.text(this.countNum);
        }
      });
  });
  counted = 1;


// Home banner slider (main)
if ($('.banner-slider-main').length > 0) {
  $('.banner-slider-main').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    infinite: true,
    vertical: true,
    speed: 1000,
    loop: true,
    asNavFor: '.banner-thumb-slider',
    autoplay: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: true,
          vertical: false
        }
      }
    ]
  });
}

// Thumbnails
if ($('.banner-thumb-slider').length > 0) {
  var $thumb = $('.banner-thumb-slider');

  function applyCenterToCurrent() {
    var $slides = $thumb.find('.slick-slide');
    $slides.removeClass('slick-center');
    // use slick-current as the source of truth
    $slides.filter('.slick-current').addClass('slick-center');
  }

  function syncThumbTo(idx) {
    // Jump thumbs to the same logical index (no animation)
    if ($thumb.hasClass('slick-initialized')) {
      $thumb.slick('slickGoTo', idx, true);
      applyCenterToCurrent();
    }
  }

  // Bind BEFORE init so we catch 'init'
  $thumb.on('init reInit setPosition afterChange', function () {
    applyCenterToCurrent();
  });

  // When main slider changes, sync thumbs and re-center class
  $('.banner-slider-main').on('afterChange', function (e, slick, currentSlide) {
    syncThumbTo(currentSlide);
  });

  // Clicking a thumb should also re-assert the single center class
  $thumb.on('click', '.slick-slide', function () {
    // delay to let Slick update slick-current
    setTimeout(applyCenterToCurrent, 0);
  });

  // Initialize thumbs (keep 4 visible & centerMode)
  $thumb.slick({
    slidesToShow: 4,
    arrows: false,
    asNavFor: '.banner-slider-main',
    dots: false,
    speed: 1000,
    slidesToScroll: 1,
    touchMove: true,
    focusOnSelect: true,
    centerMode: true,
    infinite: true,
    centerPadding: 0,
    vertical: true
  });

  // First pass
  setTimeout(function () {
    var main = $('.banner-slider-main').slick('getSlick');
    syncThumbTo(main ? main.currentSlide : 0);
  }, 0);
}



  // client logo 
  if($('.client-logo-slider').length > 0 ){
  $('.client-logo-slider').slick({
    slidesToShow: 5,
    dots: false,
    infinite: true,
    speed: 1000,
    loop: true,
    arrows: true,
    centerMode: true,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 574,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      }],
  });
  }
  // service-slider
  if($('.service-slider').length > 0 ){
  $('.service-slider').slick({
    slidesToShow: 3,
    dots: false,
    infinite: true,
    speed: 1000,
    loop: true,
    arrows: true,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 574,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 430,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });
  }
  //DATE AND TIME 
  if($('.date-slider').length > 0 ){
  $('.date-slider').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    infinite: false,
    speed: 1000,
    autoplay: false,
    prevArrow: '<div class="slide-arrow slick-prev"><svg  width="7" height="10" viewBox="0 0 7 10" fill="none"><path d="M6 9L2 5L6 1" stroke="#00439C" stroke-width="1.5" stroke-linecap="round"/></svg></div>',
    nextArrow: '<div class="slide-arrow slick-next"><svg  width="7" height="10" viewBox="0 0 7 10" fill="none"><path d="M1 9L5 5L1 1" stroke="#00439C" stroke-width="1.5" stroke-linecap="round"/></svg></div>',
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 6,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 574,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 370,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }
    ]
  });
  }
  // // hour
  if($('.time-slider').length > 0 ){
  $('.time-slider').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    infinite: false,
    speed: 1000,
    autoplay: false,
    prevArrow: '<div class="slide-arrow slick-prev"><svg  width="7" height="10" viewBox="0 0 7 10" fill="none"><path d="M6 9L2 5L6 1" stroke="#00439C" stroke-width="1.5" stroke-linecap="round"/></svg></div>',
    nextArrow: '<div class="slide-arrow slick-next"><svg  width="7" height="10" viewBox="0 0 7 10" fill="none"><path d="M1 9L5 5L1 1" stroke="#00439C" stroke-width="1.5" stroke-linecap="round"/></svg></div>',
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 574,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 370,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }
    ]
  });
  }
  // pro-cat-slider
  if($('.pro-cat-slider').length > 0 ){
  $('.pro-cat-slider').slick({
    slidesToShow: 4,
    dots: false,
    infinite: true,
    speed: 1000,
    loop: true,
    arrows: true,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 450,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });
  }
  // testimonials slider 
  if($('.testi-image-slider').length > 0 ){
  $('.testi-image-slider').slick({
    slidesToShow: 1,
    dots: false,
    infinite: true,
    speed: 1200,
    loop: true,
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: false,
    asNavFor: '.testi-content-slider',
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: true,
        },
      }
    ]
  });
  }
  if($('.testi-content-slider').length > 0 ){
  $('.testi-content-slider').slick({
    slidesToShow: 1,
    dots: false,
    infinite: true,
    speed: 1200,
    loop: true,
    arrows: true,
    fade: true,
    autoplay: true,
    autoplaySpeed: 5000,
    cssEase: 'ease-in-out',
    asNavFor: '.testi-image-slider',
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: false,
        },
      }
    ]
  });
  }
// blog-main-slider
  if($('.blog-main-slider').length > 0 ){
  $('.blog-main-slider').slick({
    slidesToShow: 4,
    dots: false,
    infinite: true,
    speed: 1000,
    loop: true,
    arrows: true,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 450,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });
  }
  // pdp-image-slider-main
  if($('.pdp-image-slider-main').length > 0 ){
    $('.pdp-image-slider-main').slick({
      slidesToShow: 1,
      dots: false,
      infinite: true,
      speed: 1200,
      loop: true,
      arrows: true,
      fade:true,
    });
    }

 // Slick lightbox 
    if($('.lightbox').length>0) {
        $('.lightbox').slickLightbox({
           itemSelector: 'a.open-lightbox',
           caption: 'caption',
           prevArrow: '<button class="slide-arrow slick-prev"><svg viewBox="0 0 10 5"><path d="M2.37755e-08 2.57132C-3.38931e-06 2.7911 0.178166 2.96928 0.397953 2.96928L8.17233 2.9694L7.23718 3.87785C7.07954 4.031 7.07589 4.28295 7.22903 4.44059C7.38218 4.59824 7.63413 4.60189 7.79177 4.44874L9.43039 2.85691C9.50753 2.78197 9.55105 2.679 9.55105 2.57146C9.55105 2.46392 9.50753 2.36095 9.43039 2.28602L7.79177 0.69418C7.63413 0.541034 7.38218 0.544682 7.22903 0.702329C7.07589 0.859976 7.07954 1.11192 7.23718 1.26507L8.1723 2.17349L0.397965 2.17336C0.178179 2.17336 3.46059e-06 2.35153 2.37755e-08 2.57132Z"></path></svg></button>',
           nextArrow: '<button class="slide-arrow slick-next"><svg viewBox="0 0 10 5"><path d="M2.37755e-08 2.57132C-3.38931e-06 2.7911 0.178166 2.96928 0.397953 2.96928L8.17233 2.9694L7.23718 3.87785C7.07954 4.031 7.07589 4.28295 7.22903 4.44059C7.38218 4.59824 7.63413 4.60189 7.79177 4.44874L9.43039 2.85691C9.50753 2.78197 9.55105 2.679 9.55105 2.57146C9.55105 2.46392 9.50753 2.36095 9.43039 2.28602L7.79177 0.69418C7.63413 0.541034 7.38218 0.544682 7.22903 0.702329C7.07589 0.859976 7.07954 1.11192 7.23718 1.26507L8.1723 2.17349L0.397965 2.17336C0.178179 2.17336 3.46059e-06 2.35153 2.37755e-08 2.57132Z"></path></svg></button>',
           navigateByKeyboard: true,
           layouts: {
              closeButton: '<button class="close"><svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50" fill="none"><path d="M27.7618 25.0008L49.4275 3.33503C50.1903 2.57224 50.1903 1.33552 49.4275 0.572826C48.6647 -0.189868 47.428 -0.189965 46.6653 0.572826L24.9995 22.2386L3.33381 0.572826C2.57102 -0.189965 1.3343 -0.189965 0.571605 0.572826C-0.191089 1.33562 -0.191186 2.57233 0.571605 3.33503L22.2373 25.0007L0.571605 46.6665C-0.191186 47.4293 -0.191186 48.666 0.571605 49.4287C0.952952 49.81 1.45285 50.0007 1.95275 50.0007C2.45266 50.0007 2.95246 49.81 3.3339 49.4287L24.9995 27.763L46.6652 49.4287C47.0465 49.81 47.5464 50.0007 48.0463 50.0007C48.5462 50.0007 49.046 49.81 49.4275 49.4287C50.1903 48.6659 50.1903 47.4292 49.4275 46.6665L27.7618 25.0008Z" fill="white"></path></svg></button>'
           }
        });
      
      $(".pdp-main-img").click(function() {
        if($('a.pdp-main-img').hasClass('open-lightbox')){
          $('body').addClass('no-scroll');
        }else{
          $('body').removeClass('no-scroll');
        }
      });
      $('body').on('click', '.slick-lightbox-inner .close, .slick-lightbox-hide', function() {
        $('body').removeClass('no-scroll');
      });
    }

    // product slider zoom
    $('.pdp-main-img.zoom').each(function() {
      $(this).zoom({
        url: false,
        callback: false,
        target: false,
        duration: 120,
        on: 'mouseover', // other options: grab, click, toggle
        touch: true, // enables a touch fallback
        onZoomIn: false,
        onZoomOut: false,
        magnify: 2
      });
    });
  
    // product-slider
    if($('.product-slider').length > 0 ){
      $('.product-slider').slick({
        slidesToShow: 4,
        dots: false,
        infinite: true,
        speed: 1000,
        loop: true,
        arrows: true,
        responsive: [
          {
            breakpoint: 991,
            settings: {
              slidesToShow: 3,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 400,
            settings: {
              slidesToShow: 1,
            },
          },
        ],
      });
      }
      // apoinment slider 
      $('.right-slider').slick({
        dots: false,
        infinite: true,
        speed: 1000,
        loop: true,
        arrows: true,
        slidesToShow: 1,
        fade: true,
        cssEase: 'cubic-bezier(0.7, 0, 0.3, 1)',
        touchThreshold: 100,
      });

 // currency-nice-select
          $('body').on('click', '.currency .nice-select', function (e) {
            e.stopPropagation(); // Stop the event from propagating to the body
            $(this).toggleClass('open');
          });
          $('body').on('click', function (e) {
            $('.currency .nice-select').removeClass('open');
          });
          
          function currencyFormSubmit(event) {
            event.target.form.submit();
          }
          
          document.querySelectorAll('.currency .nice-select .list li').forEach(function (currencyItem) {
            currencyItem.addEventListener('click', function () {
              // Trigger change event on the associated select element
              var selectElement = this.closest('.currency').querySelector('select');
              if (selectElement) {
                // Set the selected option based on the data-currency attribute of the clicked li
                selectElement.value = this.dataset.currency;
                
                // Trigger change event
                var event = new Event('change', { bubbles: true });
                selectElement.dispatchEvent(event);
          
                // Submit the form
                currencyFormSubmit({ target: selectElement });
              }
            });
          });


  // notify me
  $('body').on('click','.notify-btn', function(e) {
      e.preventDefault();
      $('body').addClass('no-scroll notify-active');
      $('.out-of-stock-form,.overlay').addClass('active');
    });
   $('body').on('click','.overlay,.notify-popup-close', function(e) {
      e.preventDefault();
     $('body').removeClass('no-scroll notify-active');
      $('.out-of-stock-form,.overlay').removeClass('active');
    });

  // sticky addtocart button

if($('body').hasClass('product')){
$.fn.isInViewport = function() {
    var elementTop = this.offset().top;
    var elementBottom = elementTop + this.outerHeight();

    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();

    return elementBottom > viewportTop && elementTop < viewportBottom;
};

    $(window).scroll(function() {
        if ($('.cart-btn.product-button').isInViewport()) {
          $('.products-add-cart-sticky').removeClass('show-btn');
        } else {
          $('.products-add-cart-sticky').addClass('show-btn');
        }
    });
    }

   $(".stickyOpt.nice-select").on('click', function(){
		$(this).toggleClass('open');
    });
    $(".stickyOpt .vrOpt").on('click', function(e){
        var sectionId = $('.pdp-home-section .container').attr('data-section-id');
		var number = $(this).data('no');
        $(".stickyOpt .selectedOpt").html($(this).html());
      	$(this).toggleClass('open');
      	this.productvariants = JSON.parse(document.getElementById('variants'+sectionId).innerHTML);
        var stOpt = this.productvariants[number],
            o1 = stOpt.option1, o2 = stOpt.option2, o3 = stOpt.option3;
        $('.stickCtImg').attr('src', stOpt.featured_image.src+'&width=100');
        if($('select.single-option-selector').length){
        } else {
            if(o2 != null){var stOpt2 = o2.replace(/'/g, "\\'");$(".swatchInput[value='"+stOpt2+"']").prop("checked",true)}
            if(o3 != null){var stOpt3 = o3.replace(/'/g, "\\'");$(".swatchInput[value='"+stOpt3+"']").prop("checked",true)}
            if(o1 != null){var stOpt1 = o1.replace(/'/g, "\\'");$(".swatchInput[value='"+stOpt1+"']").trigger('click')}
        }
    });
  
      $(".stickyQty .quantity__button").on("click", function(){
      var qtyField = $('.mianQty'),oldValue = $(qtyField).val(),newVal = 1;
      if ($(this).is(".quantity-increment")) {
        newVal = parseInt(oldValue) + 1;
      } else if (oldValue > 1) {
        newVal = parseInt(oldValue) - 1;
      }
      $(qtyField).val(newVal).trigger('change');
    });
    $('.mianQty').on("change", function(){
      $('#stquantity').val($(this).val());
    });
// end sticky
  

// quickview
  $('body').on('click', '.quickview-close', function(e) {
    e.preventDefault();
    $('.quickview-popup').hide();
    $('body').removeClass('no-scroll quick-active');
  });
  
  $('body').on('click', '.quickview-btn', function(e) {
    e.preventDefault();
    $('body').addClass('no-scroll quick-active');
    var href= '/products/'+$(this).find('a').data('handle')+'?view=qv';
    $.get(href, function(product) {
      $('.quickview_popup_data').html(product);
      $('.qv_slider').slick({
          autoplay: false,
          slidesToShow: 1,
          speed: 1000,
          slidesToScroll: 1,
          arrows: true,
          dots: false,
          buttons: false,
          infinite: false,
          loop: false
      });

    });
    $('.quickview-popup').show();
  });

 $('body').on('change', '.quickview_popup_data .colors-box .button', function() {
    var data_val = $(this).children('input:checked').val();
   $(this).parents('.colors-box').find('.option-label').text(data_val);
   
    var selectedValues = [];

    // Collect selected option values
    $('.quickview_popup_data .colors-box .button input:checked').each(function() {
    var selectedValue = $(this).val();
    if (selectedValue) {
      selectedValues.push(selectedValue);
    }
  });
var joinedValues = selectedValues.join(' / ');


    $('.variant-qv').each(function() {
     var variant_title = $(this).data('title'); 
     var variant_img = $('.variant-qv[data-title="'+variant_title+'"]').data('img');
     var variant_price = $('.variant-qv[data-title="'+variant_title+'"]').data('price');
     var qv_btn =  $('.variant-qv[data-title="'+variant_title+'"]').data('avail');
     var variant_id = $('.variant-qv[data-title="'+variant_title+'"]').data('id');
      variant_title = String(variant_title);
      joinedValues = String(joinedValues);
      
      if(variant_title === joinedValues){
        
      var slideIndex = $('.qv_slider .qv-pro-slider-img img[data-img="'+variant_img+'"]').parent().index();
      $('.qv_slider').slick('slickGoTo', slideIndex)
        
        $('.qv-price').find('.price-item--regular').text(variant_price);

        if(qv_btn === true ){
          $('#quick-view-temp .product-form__submit').find('span').text('Add to Cart');
          $('#quick-view-temp .product-form__submit').removeAttr('disabled');
        }else{
          $('#quick-view-temp .product-form__submit').find('span').text('Sold out');
          $('#quick-view-temp .product-form__submit').attr('disabled', 'disabled');
        }

        $('input[name="id"]').val(variant_id);
        
      }
  });
  
  });
// end quickview

   // custom reviews on product page
  $(window).on('load', function() {
    $(".left-side-content").find(".jdgm-prev-badge").append("<a class='product-write-review d-flex align-items-center'><svg xmlns='http://www.w3.org/2000/svg' fill='#0093af' id='Outline' viewBox='0 0 24 24' width='16' height='16'><path d='M22.853,1.148a3.626,3.626,0,0,0-5.124,0L1.465,17.412A4.968,4.968,0,0,0,0,20.947V23a1,1,0,0,0,1,1H3.053a4.966,4.966,0,0,0,3.535-1.464L22.853,6.271A3.626,3.626,0,0,0,22.853,1.148ZM5.174,21.122A3.022,3.022,0,0,1,3.053,22H2V20.947a2.98,2.98,0,0,1,.879-2.121L15.222,6.483l2.3,2.3ZM21.438,4.857,18.932,7.364l-2.3-2.295,2.507-2.507a1.623,1.623,0,1,1,2.295,2.3Z'></path></svg> Write a Review</a>");
  });
  
});

if ($(".my-acc-column").length > 0) {
  jQuery(function ($) {
    var topMenuHeight = $("#daccount-nav").outerHeight();
    $("#account-nav").menuScroll(topMenuHeight);
    $(".account-list li:first-child").addClass("active");
  });
  // COPY THE FOLLOWING FUNCTION INTO ANY SCRIPTS
  jQuery.fn.extend({
    menuScroll: function (offset) {
      // Declare all global variables
      var topMenu = this;
      var topOffset = offset ? offset : 0;
      var menuItems = $(topMenu).find("a");
      var lastId;
      // Save all menu items into scrollItems array
      var scrollItems = $(menuItems).map(function () {
        var item = $($(this).attr("href"));
        if (item.length) {
          return item;
        }
      });
      // When the menu item is clicked, get the #id from the href value, then scroll to the #id element
      $(topMenu).on("click", "a", function (e) {
        var href = $(this).attr("href");
        var offsetTop = href === "#" ? 0 : $(href).offset().top - topOffset;
        function checkWidth() {
          var windowSize = $(window).width();
          if (windowSize <= 767) {
            $('html, body').stop().animate({
              scrollTop: offsetTop - 200
            }, 300);
          }
          else {
            $('html, body').stop().animate({
              scrollTop: offsetTop - 100
            }, 300);
          }
        }
        // Execute on load
        checkWidth();
        // Bind event listener
        $(window).resize(checkWidth);
        e.preventDefault();
      });
      // When page is scrolled
      $(window).scroll(function () {
        function checkWidth() {
          var windowSize = $(window).width();
          if (windowSize <= 767) {
            var nm = $("html").scrollTop();
            var nw = $("body").scrollTop();
            var fromTop = (nm > nw ? nm : nw) + topOffset;
            // When the page pass one #id section, return all passed sections to scrollItems and save them into new array current
            var current = $(scrollItems).map(function () {
              if ($(this).offset().top - 250 <= fromTop)
                return this;
            });
            // Get the most recent passed section from current array
            current = current[current.length - 1];
            var id = current && current.length ? current[0].id : "";
            if (lastId !== id) {
              lastId = id;
              // Set/remove active class
              $(menuItems)
                .parent().removeClass("active")
                .end().filter("[href='#" + id + "']").parent().addClass("active");
            }
          }
          else {
            var nm = $("html").scrollTop();
            var nw = $("body").scrollTop();
            var fromTop = (nm > nw ? nm : nw) + topOffset;
            // When the page pass one #id section, return all passed sections to scrollItems and save them into new array current
            var current = $(scrollItems).map(function () {
              if ($(this).offset().top <= fromTop)
                return this;
            });
            // Get the most recent passed section from current array
            current = current[current.length - 1];
            var id = current && current.length ? current[0].id : "";
            if (lastId !== id) {
              lastId = id;
              // Set/remove active class
              $(menuItems)
                .parent().removeClass("active")
                .end().filter("[href='#" + id + "']").parent().addClass("active");
            }
          }
        }
        // Execute on load
        checkWidth();
        // Bind event listener
        $(window).resize(checkWidth);
      });
    }
  });
}
/******  STEPPY FORM  CSS  ******/
var totalSteps = $(".steps li").length;
$(".submit").on("click", function(){
  return false; 
});

$(".steps li:nth-of-type(1)").addClass("active");
$(".myContainer .step-container:nth-of-type(1)").addClass("active");

$(".step-container").on("click", ".next", function() { 
  $(".steps li").eq($(this).parents(".step-container").index() + 1).addClass("active"); 
  $(this).parents(".step-container").removeClass("active").next().addClass("active"); 
  $('.right-slider').slick('refresh');  
});

$(".step-container").on("click", ".back", function() {  
  $(".steps li").eq($(this).parents(".step-container").index() - totalSteps).removeClass("active"); 
  $(this).parents(".step-container").removeClass("active").prev().addClass("active"); 
  $('.right-slider').slick('refresh');
}); 
/******  STEPPY FORM  CSS  End******/
function responsiveMenu(){
  if(jQuery(window).width() < 768) {
    $('.product-filter-column').prependTo('.product-heading-row .container .row');
  }
  else { 
    $('.product-filter-column').prependTo('.product-list-row');
    if($('body').hasClass('mobile-open') ){
      $('body').removeClass('mobile-open no-scroll overflow-hidden-mobile');
      $('.overlay').removeClass('active');
     }
  }
  
    if(jQuery(window).width() < 768) {
     if(!$('.mobile-lag').length > 0 ){
      const newDiv = document.createElement('ul');
      newDiv.className = 'mobile-lag d-flex aling-item-center';
      $(newDiv).insertAfter('.menu-close-icon');
      $('.languages , .currency').prependTo('.mobile-lag');
    }else{
       return false;
    }
  }
  else {
    $('.currency, .languages').insertAfter('.profile-header');
    $('.mobile-lag').remove();
  }
  
}
jQuery(document).ready(function() {
  responsiveMenu();
});
jQuery(window).resize(function() {
  responsiveMenu();
});
  /****  TAB Js ****/
  $('ul.tabs li').click(function () {
    var $this = $(this);
    var $theTab = $(this).attr('data-tab');
    console.log($theTab);
    if ($this.hasClass('active')) {
      // do nothing
    } else {
      $this.closest('.tabs-wrapper').find('ul.tabs li, .tabs-container .tab-content').removeClass('active');
      $('.tabs-container .tab-content[id="' + $theTab + '"], ul.tabs li[data-tab="' + $theTab + '"]').addClass('active');
    }
  });
function countDownIni(countdown) {
  $(countdown).each(function () {
    var countdown = $(this);
    var promoperiod;
    if (countdown.attr('data-promoperiod')) {
      promoperiod = new Date().getTime() + parseInt(countdown.attr('data-promoperiod'), 10);
    } else if (countdown.attr('data-countdown')) {
      promoperiod = countdown.attr('data-countdown');
    }
    if (Date.parse(promoperiod) - Date.parse(new Date()) > 0) {
      $(this).addClass('countdown-block');
      countdown.countdown(promoperiod, function (event) {
        // countdown.html(event.strftime('%-w weeks %-d days %Hh %Mm %Ss'));
        countdown.html(event.strftime('<span><span>%D</span><span class="dots"> : </span></span>' + '<span><span>%H</span><span class="dots"> : </span></span>' + '<span><span>%M</span><span class="dots"> : </span></span>' + '<span><span class="second">%S</span></span>'));
      });
    }
    if (Date.parse(promoperiod) - Date.parse(new Date()) < 0) {
        $(this).parent().css('display','none');
     }
  });
}